import { cx } from "@/utils/cx";
import type { ReactNode } from "react";

/**
 * Gymkee 2027 badge (spec badge 1.6; sheet DS02).
 *
 * A 24 pill carrying a soft tint and its readable text colour, never a solid fill and never
 * paper on a block of colour. Neutral by default, and never orange on this app: orange's one
 * job on a pay page is the primary action, so a badge that took it would be the second one
 * (gate 3.1, 3.3).
 */

export type BadgeTone = "neutral" | "success" | "warning" | "danger" | "info";

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}

const TONE_CLASS: Record<BadgeTone, string> = {
  neutral: "ds-badge-neutral",
  success: "ds-badge-success",
  warning: "ds-badge-warning",
  danger: "ds-badge-danger",
  info: "ds-badge-info",
};

export function Badge({ tone = "neutral", children, className }: BadgeProps) {
  return (
    <span className={cx("ds-badge", TONE_CLASS[tone], className)}>
      {children}
    </span>
  );
}
